import { Routes } from '@angular/router';

export const COMMERCIAL_CONDITIONS_ROUTES: Routes = [
  {
    path: 'commercial-conditions',
    loadComponent: () => import('./commercial-conditions-list/commercial-conditions-list.component')
      .then(m => m.CommercialConditionsListComponent)
  }
];
